import gsap from "gsap";
import Animations from "./animations";
import Header from "./header";
const Feature = (() => {

    const SELECTOR_MODULE = ".module-container__feature";

    const initialize = () => {


        const modules = document.querySelectorAll(`${SELECTOR_MODULE}`);

        modules.forEach(module => {

            if (module.classList.contains('bike')) {

                initBikeAnimations(module);
            }
            if (module.classList.contains('motor')) {

                initMotorAnimations(module);
            }
        })

    };

    const initializeBike = () => {
        const module = document.querySelector(`${SELECTOR_MODULE}.bike`);

        if (!module) return;

        initBikeAnimations(module);
    };

    const initializeMotor = () => {
        const module = document.querySelector(`${SELECTOR_MODULE}.motor`);

        if (!module) return;

        initMotorAnimations(module);
    };

    const initBikeAnimations = (module) => {


        if (!module) return;

        // animated elements
        const moduleText = module.querySelector('.content__text');
        const moduleTextElements = moduleText.querySelectorAll('div[class*=col] > *');
        const moduleImage = module.querySelector('.content__media img');

        gsap.timeline({
            scrollTrigger: {
                trigger: module,
                start: () => `top top+=${getOffset()}`,
                /* end: "top 10%", */
                end: "+=150%",
                pin: true,
                scrub: 1,
                once: false,
                markers: false,
                invalidateOnRefresh: true,
            }
        })
            .to(moduleImage, { x: '-36%', duration: 5 })
            /* .fromTo(moduleText,
                { autoAlpha: 0, y: 30 },
                { autoAlpha: 1, y: 0, ease: "none", duration: 0.5 },
                "-=0.2" // overlap (before translate ends)
            ) */
            .from(moduleTextElements,
                { autoAlpha: 0, y: 30, ease: "none", duration: 5, stagger: .5 },
            "-=1" // overlap (before translate ends)
            ).to({},{ duration: 2 }, "+=2")
            .scrollTrigger.refresh();


    };

    const initMotorAnimations = (module) => {

        if (!module) return;


        // TODO: handle diff media
        /* let mm = gsap.matchMedia();
        mm.add("(min-width: 1200px)", () => {});
        mm.add("(max-width: 1199px)", () => {}); */

        // animated elements
        const moduleText = module.querySelector('.content__text');
        const moduleTextElements = moduleText.querySelectorAll('div[class*=col] > *');
        const moduleImage = module.querySelector('.content__media img');


        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: module,
                start: () => `top top+=${getOffset()}`,
                end: "+=100%",
                pin: true,
                scrub: 1,
                once: false,
                markers: false,
                invalidateOnRefresh: true,
            }
        })
            .from(moduleTextElements,
                { autoAlpha: 0, y: 30, ease: "none", duration: 1, stagger: .5 },
            "-=0.5" // overlap (before translate ends)
            )
            .fromTo(moduleImage,
                { x: '-100%' },
                { x: '-36%', duration: 2 },
                "-=0.2")
            .to({}, { duration: 2 }, "+=2"); // wait before scroll to next el
        /* .scrollTrigger.refresh(); */

    };

    const getOffset = () => Header.getCurrentHeight();

    return {
        initialize,
        initializeBike,
        initializeMotor
    }

})();


export default Feature;